import React from "react";
import { connect } from "react-redux";
import Typography from "@mui/material/Typography";
import ThemeSelection from "./ThemeSelection";
import SpacingSelection from "./SpacingSelection";
import AssignmentPinsProvider from "components/Assignment/AssignmentPinsProvider";
import AssignmentPinsSelection from "./AssignmentPinsSelection";
import { userHasAnyRight } from "selectors/rights";
import { ASSIGN, ASSIGNMENTTOOLINSURANCE, ASSIGNMENTTOOLAPPRAISAL } from "typeConstants/rights";

interface AppearanceProps {
  // Redux
  showPinSelection: boolean;
}

const Appearance = (props: AppearanceProps) => {
  return (
    <div>
      <Typography>Theme</Typography>
      <ThemeSelection />
      <br />
      <Typography>Spacing</Typography>
      <SpacingSelection />
      {props.showPinSelection && <>
        <br />
        <Typography>Assignment Tool Pins</Typography>
        <AssignmentPinsProvider>
          <AssignmentPinsSelection />
        </AssignmentPinsProvider>
      </>} 
    </div>
  );
};

const mapStateToProps = state => ({
  showPinSelection: userHasAnyRight(ASSIGN, ASSIGNMENTTOOLINSURANCE, ASSIGNMENTTOOLAPPRAISAL)(state),
});

export default connect(mapStateToProps)(Appearance);